export class ErrorReport {
    description?: string;
    report?: string[];
}
